const heroMain = document.querySelector('.hero-main');
const button = document.querySelector('.next-section-button');
const ctaButton = document.querySelector('.hero-cta-button');

function handleNextButton(event) {
	event.preventDefault();
	const nextSection = heroMain.nextElementSibling;
	if (nextSection) {
		const yOffset = 50; // adjust this value for your offset
		const y = nextSection.getBoundingClientRect().top + window.scrollY + yOffset;
		window.scroll({ top: y, behavior: 'smooth' });
	}
	this.blur();
}

button.addEventListener('click', handleNextButton);

button.addEventListener('keydown', function (event) {
	if (event.key === 'Enter' || event.key === ' ') {
		handleNextButton(event);
	}
	this.blur();
});

window.addEventListener('scroll', function () {
	const scrollPosition = window.scrollY || window.scrollY;
	const fadeHeight = heroMain.offsetHeight / 3;

	if (scrollPosition > fadeHeight) {
		button.classList.add('fade-out');
		ctaButton.classList.add('fade-out');
	} else {
		button.classList.remove('fade-out');
		ctaButton.classList.remove('fade-out');
	}
});
